import { BILAN_JEUNES, CONSTAT, FONDS, FRANCE_AVENIR_IMG } from "./content2";
import { DataTable, SectionShell, StatGrid, Zoomable } from "./blocks";
import { useInView } from "./useInView";
import { Simulateur } from "./Simulateur";

const Martien = () => (
  <div className="grid lg:grid-cols-[1fr_380px] gap-12 items-start">
    <div className="mm-body space-y-4 max-w-[62ch]">
      <h2 className="disp mm-h2">France Avenir · Le Martien de passage</h2>
      <p className="disp text-2xl text-mm-red">77 ans. L'âge n'est qu'un chiffre.</p>
      <p>« Bonjour. Je suis un Martien de passage. J'ai pris la place d'un Terrien pendant 77 ans pour regarder, compter et faire un rapport comptable. Sans passion. Sans débat. Je ne cherche pas à convaincre. Je pose la question. Encore et encore. »</p>
      <p>Les chiffres parlent d'eux-mêmes. On ne leur fait pas dire ce que l'on a envie. Une entrée est une entrée. Une sortie est une sortie. Une dette est une dette. Un actif est un actif.</p>
      <p className="font-bold">La règle de trois ne vote pas. Elle calcule.</p>
      <p>Ne sortons pas du sujet. La Grande Question concerne notre territoire : la France. Le monde continuera à tourner. La Terre aussi. Nous commençons par ce que nous pouvons mesurer, comprendre et décider ici.</p>
      <p className="mm-lab text-mm-golddark pt-2">Informer · Comprendre · Agir · Ensemble</p>
    </div>
    <Zoomable src={FRANCE_AVENIR_IMG} alt="Affiche France Avenir — La Grande Question en huit cases" testid="france-avenir-poster" />
  </div>
);

const Fonds = () => (
  <div>
    <h3 className="disp text-3xl md:text-4xl">Le fonds France Avenir</h3>
    <p className="mm-body mt-3 max-w-[62ch]">Nous sommes tous, d'une certaine manière, actionnaires de l'Entreprise France. Chacun peut participer selon ses moyens. Un effort aujourd'hui pour plus d'opportunités demain.</p>
    <ul className="st grid sm:grid-cols-2 lg:grid-cols-5 gap-4 mt-8">
      {FONDS.map((f) => (
        <li key={f.amount} className="bg-mm-paper border-2 border-mm-ink p-4" data-testid="fonds-palier">
          <p className="disp text-2xl text-mm-red">{f.amount}</p>
          <p className="text-sm mt-2">{f.text}</p>
        </li>
      ))}
    </ul>
    <p className="mt-6 border-l-4 border-mm-gold pl-4 font-bold">Don ou obligation à 1 % ou 2 % sur 10 ans — une façon simple et efficace de participer au fonds France Avenir.</p>
    <p className="text-xs mt-3 opacity-70">Proposition de réflexion présentée dans le dossier : il ne s'agit pas d'une collecte ouverte sur ce site.</p>
    <div className="mt-10"><Simulateur /></div>
  </div>
);

const Jeunes = () => (
  <div>
    <h3 className="disp text-3xl md:text-4xl">Et si on donnait le bilan aux jeunes ?</h3>
    <p className="mm-body mt-3 max-w-[62ch]">Aux lycéens, aux étudiants, à ceux qui vivront avec les choix faits aujourd'hui. Posez plein, plein de questions. France Avenir vous appartient, avec papa, maman et les grands-parents.</p>
    <div className="mt-8"><DataTable testid="bilan-jeunes-table" head={["Bilan simplifié de la France", "Entrées (Md€)", "Sorties (Md€)", "Dette (Md€)", "Actifs (Md€)"]} rows={BILAN_JEUNES} /></div>
    <p className="mm-body mt-6">Les chiffres sont donnés. Les hypothèses sont visibles. La réponse n'est pas imposée : chacun peut refaire le calcul. <strong>Comprenez les chiffres. Faites-les parler. Vérifiez-les. Recommencez.</strong></p>
  </div>
);

export const FranceAvenir = () => {
  const [ref, cls] = useInView(0.05);
  return (
    <SectionShell id="france-avenir" label="Introduction · France Avenir" bg="bg-mm-paper" innerRef={ref} cls={cls}>
      <Martien />
      <div>
        <h3 className="disp text-3xl md:text-4xl mb-8">Le constat</h3>
        <StatGrid items={CONSTAT} />
      </div>
      <Fonds />
      <Jeunes />
      <p className="disp text-3xl md:text-4xl text-mm-red">France, réveille-toi ! <span className="text-mm-ink">Moins de discours. Plus de solutions. Ensemble, c'est possible !</span></p>
    </SectionShell>
  );
};
